import { render, staticRenderFns } from "./window.vue?vue&type=template&id=4d8cc360&scoped=true&"
import script from "./window.vue?vue&type=script&lang=js&"
export * from "./window.vue?vue&type=script&lang=js&"
import style0 from "./window.vue?vue&type=style&index=0&id=4d8cc360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8cc360",
  null
  
)

export default component.exports